import { ChatMessage, type ChatMessageProps } from '~/components/chat/ChatMessage'

export type AssistantResponseProps = ChatMessageProps

export function AssistantResponse(props: AssistantResponseProps) {
  return <ChatMessage {...props} />
}
